import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMastodonComponent } from './simple-icons-mastodon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMastodonComponent ],
    exports:      [ SimpleIconsMastodonComponent ],
    bootstrap:    []
})
export class SimpleIconsMastodonModule {}
